/**
 * Script para cargar y aplicar el tema basado en el InitialData
 * Este script se debe importar en el componente principal de la aplicación
 */
import { useStates } from '../../router/states';
import { watch, onMounted, nextTick } from 'vue';

export function initializeTheme() {
    const { userState } = useStates();
    let themeApplied = false;
    
    // Función para aplicar el tema basado en el InitialData
    const applyThemeFromInitialData = async (forceReload = false) => {
        if (userState?.data?.value) {
            try {
                // Verificar si hay configuración de layout en el InitialData
                if (userState.data.value.layoutConfig) {
                    const layoutConfig = JSON.parse(userState.data.value.layoutConfig);
                    
                    if (window.applyThemeFromConfig) {
                        await nextTick();
                        window.applyThemeFromConfig(layoutConfig, forceReload);
                        themeApplied = true;
                        
                        try {
                            localStorage.setItem('layout_config', JSON.stringify(layoutConfig));
                        } catch (e) {
                            console.warn('Could not save layout config to localStorage:', e);
                        }
                    }
                }
            } catch (error) {
                console.error('Error applying theme from initial data:', error);
            }
        }
    };
    
    onMounted(async () => {
        await new Promise(resolve => setTimeout(resolve, 100));
        await applyThemeFromInitialData(false);
    });
    
    watch(() => userState.data.value, async (newValue, oldValue) => {
        if (newValue && (!oldValue || newValue.id !== oldValue.id)) {
            await applyThemeFromInitialData(true);
        }
    }, { deep: true });
    
    window.forceThemeReload = () => {
        applyThemeFromInitialData(true);
    };
}
